import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: clamp(320px, 840px, calc(100vw - 80px));

  font-family: 'Unimed-Sans-SemiBold';

  h1 {
    font-size: 1.5rem;
    text-align: left;

    @media (min-width: 768px) {
      font-size: 1.75rem;
    }
  }

  form {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    box-shadow: none;
  }
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  width: calc(100% + 1rem);
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  padding-right: 1rem;

  overflow-y: auto;
  max-height: 60svh;

  &::-webkit-scrollbar {
    background: ${(props) => props.theme.colors.palet.institutional10};

    width: 0.3125rem;
    height: 0.3125rem;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.palet.institutional10};
    ${(props) =>
      css`
        outline: 0.06125rem solid ${props.theme.colors.palet.institutional10};
      `};
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 1rem;
  }
  &::-webkit-scrollbar-track {
    background: #c1c1c1;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 1rem;
  }

  & > div {
    &:nth-child(1) {
      & [data-tooltip] {
        p {
          &::before {
            bottom: initial;
            top: -10px;
            right: 8px;
            border: 5px solid #ed1651;
            border-left-color: transparent;
            border-top-color: transparent;
          }
          bottom: initial;
          top: calc(100% + 1rem);
          transform: translateY(-20px);
          z-index: 1;
        }
        &:hover {
          z-index: 1;
          p {
            transform: translateY(0px);
          }
        }
      }
    }
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;
`;

export const FormGroupLabel = styled.label`
  font-size: 1rem;
  display: flex;
  gap: 1rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  text-align: left;
`;

export const CharLimit = styled.div`
  width: 100%;
  text-align: right;
  font-size: 0.875rem;
`;

export const CheckboxGroupWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 1rem;
`;
